import {
  Box,
  Flex,
  Heading,
  IconButton,
  useColorModeValue,
} from '@chakra-ui/react';
import { ArrowLeft } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { z } from 'zod';
import DefaultPage from '../../../components/shared/DefaultPage';
import Steps from '../../../components/shared/Steps';
import { useAuth } from '../../../hooks/auth';
import { useValoresCertificadoUsuario } from '../../../services/hooks/useCustoCertificadoUsuario';
import DadosCertificado from './Steps/DadosCertificado';
import DadosFatura, { stepFaturaData } from './Steps/DadosFatura';
import Finalizar from './Steps/Finalizar';
import Pedido, { stepPedidoData } from './Steps/Pedido';

export const FormPessoaFisica = z.object({
  tipoPessoa: z.literal('2'),
  cpf: z.string(),
  cei_caepf: z.string().nonempty('Campo Obrigatório'),
  razao_nome_completo: z.string(),
  telefone: z.string(),
  celular: z.string(),
  email: z.string(),
  cep: z.string(),
  logradouro: z.string(),
  numero: z.string(),
  bairro: z.string(),
  uf: z.string(),
  cidade: z.string(),
  ibge: z.string(),
  complemento: z.string(),
  finalidade: z.string(),
});
export const FormPessoaJuridica = z.object({
  tipoPessoa: z.literal('1'),
  cnpj: z.string(),
  razao_nome_completo: z.string().nonempty('Campo Obrigatório'),
  fantasia: z.string(),
  representante: z.string(),
  cpf_representante: z.string(),
  telefone: z.string(),
  celular: z.string(),
  email: z.string(),
  cep: z.string(),
  logradouro: z.string(),
  numero: z.string(),
  bairro: z.string(),
  uf: z.string(),
  cidade: z.string(),
  ibge: z.string(),
  complemento: z.string(),
  finalidade: z.string(),
});

const NovoCertificado = () => {
  // estilos
  const color = useColorModeValue('gray.800', 'white');
  const bg = useColorModeValue('white', 'gray.800');

  // contantes
  const history = useHistory();
  const steps = [
    { step: 1, title: 'Pedido' },
    { step: 2, title: 'Dados Certificados' },
    { step: 3, title: 'Dados Fatura' },
    { step: 4, title: 'Finalizar' },
  ];

  // estados
  const [pedidoData, setPedidoData] = useState<stepPedidoData>({});
  const [certificadoData, setCertificadoData] = useState({});
  const [faturaData, setFaturaData] = useState<stepFaturaData>({});
  const [step, setStep] = useState(1);

  const handleMudaStep = (novoStep: number) => {
    setStep(novoStep);
  };

  const verificaTipoPessoa = (finalidade: string | undefined) => {
    // 2 = pessoa fisica
    // 4 = cpf bird id
    if (finalidade === '2' || finalidade === '4') {
      return '1'; // pessoa fisica
    }
    // 1 = pessoa juridica
    // 3 = NF-e
    if (finalidade === '1' || finalidade === '3') {
      return '2'; // pessoa juridica
    }
    return null;
  };

  return (
    <DefaultPage>
      <Flex mt="12" align="center">
        <IconButton
          aria-label="voltar"
          variant="ghost"
          icon={<ArrowLeft />}
          bg="none"
          color={color}
          _focus={{ outline: 'none', boxShadow: 'none' }}
          onClick={() => history.push('/certificados')}
          mr="2"
        />
        <Heading fontSize="2xl">Nova Venda de Certificado Digital</Heading>
      </Flex>
      <Flex>
        <Box
          bg={bg}
          rounded="2xl"
          borderWidth="1px"
          p="4"
          pt="0"
          w="100%"
          my="4"
        >
          <Flex justify="center">
            <Steps data={steps} atual={step} />
          </Flex>
          {step === 1 && (
            <>
              <Pedido
                handleMudaStep={handleMudaStep}
                setPedidoData={setPedidoData}
                pedidoData={pedidoData}
              />
            </>
          )}
          {step === 2 && (
            <>
              <DadosCertificado
                handleMudaStep={handleMudaStep}
                certificadoData={certificadoData}
                setCertificadoData={setCertificadoData}
                tipoPessoa={verificaTipoPessoa(pedidoData?.finalidade)}
              />
            </>
          )}
          {step === 3 && (
            <>
              <DadosFatura
                handleMudaStep={handleMudaStep}
                certificadoData={certificadoData}
                setFaturaData={setFaturaData}
              />
            </>
          )}
          {step === 4 && (
            <>
              <Finalizar
                handleMudaStep={handleMudaStep}
                pedidoData={pedidoData}
                certificadoData={certificadoData}
                faturaData={faturaData}
              />
            </>
          )}
        </Box>
      </Flex>
    </DefaultPage>
  );
};

export default NovoCertificado;
